import request from '@/utils/request'

const prefix = 'user'

// 用户登录
export function login (phone, password) {
  return request({
    url: `${prefix}/back/login`,
    method: 'post',
    data: {
      phone,
      password
    }
  })
}

// 用户退出登录
export function logout () {
  return request({
    url: `${prefix}/back/logout`,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js